(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navika-home-v1"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('navika-hero-slideshow')) {
 customElements.define('navika-hero-slideshow', class extends HTMLElement {
  connectedCallback() {
   this.images = [...this.querySelectorAll('.navika-hero__image')];
   this.button = this.querySelector('button');
   this.index = 0; this.paused = false;
   this.motion = matchMedia('(prefers-reduced-motion: reduce)');
   this.refresh = () => {
    clearInterval(this.timer);
    this.button.hidden = this.motion.matches;
    if (this.paused || this.motion.matches || document.hidden) return;
    this.timer = setInterval(() => {
     const next = (this.index + 1) % this.images.length;
     if (!this.images[next].complete || !this.images[next].naturalWidth) return;
     this.images[this.index].classList.remove('is-active');
     this.images[next].classList.add('is-active');
     this.index = next;
    }, 4000);
   };
   this.toggle = () => {
    this.paused = !this.paused;
    this.button.setAttribute('aria-pressed', String(this.paused));
    this.button.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
    this.button.textContent = this.paused ? '▷' : 'Ⅱ';
    this.refresh();
   };
   this.button.addEventListener('click', this.toggle);
   this.motion.addEventListener('change', this.refresh);
   document.addEventListener('visibilitychange', this.refresh);
   this.refresh();
  }
  disconnectedCallback() {
   clearInterval(this.timer);
   this.button.removeEventListener('click', this.toggle);
   this.motion.removeEventListener('change', this.refresh);
   document.removeEventListener('visibilitychange', this.refresh);
  }
 });
}

if (!customElements.get('navika-product-carousel')) {
  customElements.define('navika-product-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.navika-carousel__track');
      this.controls = this.querySelector('.navika-carousel__controls');
      this.previous = this.querySelector('[data-direction="-1"]');
      this.next = this.querySelector('[data-direction="1"]');
      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.controls.hidden = max < 2;
        this.previous.disabled = this.track.scrollLeft < 2;
        this.next.disabled = this.track.scrollLeft >= max - 2;
      };
      this.onClick = (event) => {
        const button = event.target.closest('[data-direction]');
        if (!button) return;
        const slide = this.track.querySelector('a');
        const step = slide.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
        this.track.scrollBy({left: Number(button.dataset.direction) * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      this.controls.addEventListener('click', this.onClick);
      this.track.addEventListener('scroll', this.update, {passive:true});
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.observer.disconnect();
      this.controls.removeEventListener('click', this.onClick);
      this.track.removeEventListener('scroll', this.update);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navika-legal-links"] && !Shopify.designMode) return;
  try {
    
if (!window.navikaCookieSettingsBound) {
 window.navikaCookieSettingsBound = true;
 document.addEventListener('click', async event => {
  const button = event.target.closest('[data-nv-cookie-settings]');
  if (!button) return;
  const message = button.parentElement.querySelector('[data-nv-cookie-message]');
  button.disabled = true;
  try {
   if (!window.privacyBanner) {
    await new Promise((resolve,reject) => {
     const script=document.createElement('script');
     script.src='https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
     script.onload=resolve;script.onerror=reject;document.head.appendChild(script);
    });
   }
   await window.privacyBanner.showPreferences();
   message.textContent='';
  } catch(error) { message.textContent=button.dataset.error; }
  finally { button.disabled=false; }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navika-product"]) return;
  try {
    
if (!customElements.get('nv-mobile-buybar')) {
 customElements.define('nv-mobile-buybar', class extends HTMLElement {
  connectedCallback() {
   this.button = this.querySelector('button');
   this.scope = this.closest('.shopify-section') || document;
   this.product = this.scope.querySelector('.navika-pdp');
   if (!this.button || !this.product) return;
   this.controller = new AbortController();
   const options = { signal: this.controller.signal };
   this.sizeChosen = new URLSearchParams(location.search).has('variant');
   this.sync = () => {
    this.realButton = this.product.querySelector('[ref="addToCartButton"]');
    this.sizeInputs = [...this.product.querySelectorAll('input[data-option-name="Size"], input[data-option-name="Talla"]')];
    const needsSize = this.sizeInputs.length > 0 && !this.sizeChosen;
    const ready = this.realButton && !this.realButton.disabled && this.realButton.getAttribute('aria-disabled') !== 'true';
    this.button.disabled = !this.realButton || (!needsSize && !ready);
    this.button.setAttribute('aria-busy', this.realButton?.getAttribute('aria-busy') || 'false');
    this.button.textContent = needsSize ? this.dataset.selectSize : (this.realButton?.querySelector('.add-to-cart-text__content')?.textContent.trim() || (ready ? this.dataset.add : this.dataset.unavailable));
   };
   this.product.addEventListener('change', event => {
    if (event.target.matches('input[data-option-name="Size"], input[data-option-name="Talla"]')) this.sizeChosen = true;
    this.sync();
   }, options);
   this.button.addEventListener('click', () => {
    this.sync();
    if (this.sizeInputs.length && !this.sizeChosen) {
     const sizeBlock = this.sizeInputs[0].closest('fieldset');
     sizeBlock?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
     (this.sizeInputs.find(input => input.checked) || this.sizeInputs[0])?.focus({ preventScroll: true });
     return;
    }
    if (!this.button.disabled) this.realButton.click();
   }, options);
   this.observer = new MutationObserver(this.sync);
   this.observer.observe(this.product, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'aria-busy'] });
   this.sync();
  }
  disconnectedCallback() {
   this.controller?.abort();
   this.observer?.disconnect();
  }
 });
}

  } catch(e) { console.error(e); }
})();
})();
